import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HomeVersionerComponent } from '../ia/pages/versioner/home-versioner/home-versioner.component';
import { ArticleVersionerComponent } from './article-versioner/article-versioner.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
    declarations: [
        HomeVersionerComponent,
        ArticleVersionerComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        FormsModule
    ]
})
export class VersionerModuleModule { }
